import { render, staticRenderFns } from "./ResourceRenewFee.vue?vue&type=template&id=1a9659cc&"
import script from "./ResourceRenewFee.vue?vue&type=script&lang=js&"
export * from "./ResourceRenewFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports